"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 30.32 24",
    width: "30.32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m5.86 12.23a.76.76 0 0 0 .36.08.79.79 0 0 0 .71-.44l1.23-2.57h1a.8.8 0 0 0 0-1.6h-1.49a.82.82 0 0 0 -.67.44l-1.45 3a.79.79 0 0 0 .31 1.09z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m29.68 0h-17.68a.63.63 0 0 0 -.63.63v4.56h-5a.66.66 0 0 0 -.56.33l-3.11 5.6-2.51 2.47a.64.64 0 0 0 -.19.41v7a.63.63 0 0 0 .63.63h2.63a3.14 3.14 0 0 0 6.1 0h11.64a3.14 3.14 0 0 0 6.1 0h2.63a.64.64 0 0 0 .64-.63v-20.37a.64.64 0 0 0 -.69-.63zm-26.39 20.05h-2v-1h2.4a3 3 0 0 0 -.4 1zm3 2.69a1.9 1.9 0 1 1 1.89-1.9 1.9 1.9 0 0 1 -1.86 1.9zm-4.73-5.22v-3.1l2.28-2.28a.76.76 0 0 0 .16-.14l2.88-5.25h4.49v10.77zm19.44 2.54h-11.65a3.22 3.22 0 0 0 -.41-1h12.44a3 3 0 0 0 -.38 1zm3 2.68a1.9 1.9 0 1 1 1.89-1.9 1.9 1.9 0 0 1 -1.89 1.9zm-11.07-5.22v-16h15.83v16zm14.07 2.53a3 3 0 0 0 -.41-1h2.14v1z"
  })));
};

exports["default"] = _default;